export class FiltrosRepComercial{
   
   Usuario : string ='';
   Estado: string = '';
   idEmpresa: string = '4';
   Tipo: string = 'factura_negociada';

}